import Layout from "@/modules/ticketing/ticketing-layout"
import TicketList from "@/modules/ticketing/components/ticket-list"

const ticketingRouter = {
	path: "/ticketing",
	name: "ticketing",
	component: Layout,
	children: [
		{
			path: "",
			name: "ticketing.list",
			component: TicketList
		},
		{
			path: ":id",
			name: "ticketing.listid",
			component: TicketList
		}
	]
}

export default ticketingRouter
